import { Icon } from '@reverse-hr/design-system';
import type { FC } from 'react';
import type { TProfileInfoListItemProps } from '@components/Molecules/ProfileInfoList/ProfileInfoList.types';
import classNames from 'classnames';

export const ProfileInfoListItem: FC<TProfileInfoListItemProps> = ({
  children,
  className,
  icon,
}) => {
  const wrapperClassNames = classNames('c-profile-info-list__item', className);

  if (!children) {
    return null;
  }

  return (
    <li className={wrapperClassNames}>
      <Icon className="c-profile-info-list__icon" name={icon} /> {children}
    </li>
  );
};
